<template>
  <div class="native-input">
    <slot name="prepend" />
    <textarea
      v-if="type === 'textarea'"
      :value="modelValue"
      :rows="rows"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :disabled="disabled"
      v-bind="$attrs"
      @input="updateValue"
    />
    <input
      v-else
      :type="type"
      :value="modelValue"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :disabled="disabled"
      v-bind="$attrs"
      @input="updateValue"
    />
    <slot name="append" />
    <button
      v-if="clearable && String(modelValue ?? '')"
      class="clear-button"
      type="button"
      aria-label="清空输入"
      @click="emit('update:modelValue', '')"
    >
      ×
    </button>
    <span v-if="showWordLimit && maxlength" class="word-limit">
      {{ String(modelValue ?? "").length }}/{{ maxlength }}
    </span>
  </div>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });

withDefaults(
  defineProps<{
    modelValue?: string | number;
    type?: string;
    rows?: number;
    maxlength?: number;
    placeholder?: string;
    disabled?: boolean;
    showWordLimit?: boolean;
    clearable?: boolean;
  }>(),
  { type: "text", rows: 3, modelValue: "" },
);

const emit = defineEmits<{
  (event: "update:modelValue", value: string): void;
}>();

const updateValue = (event: Event) => {
  emit("update:modelValue", (event.target as HTMLInputElement).value);
};
</script>

<style scoped>
.native-input {
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
  gap: 6px;
}

input,
textarea {
  width: 100%;
  min-width: 0;
  padding: 9px 11px;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  background: #fff;
  color: #263238;
  font: inherit;
}

textarea {
  resize: vertical;
}

input:focus,
textarea:focus {
  border-color: #398b78;
  outline: 2px solid rgb(57 139 120 / 16%);
}

input:disabled {
  background: #f1f5f9;
  color: #64748b;
}

.word-limit {
  position: absolute;
  right: 8px;
  bottom: 6px;
  color: #84918e;
  font-size: 0.75rem;
  pointer-events: none;
}

.clear-button {
  flex: 0 0 auto;
  padding: 0 4px;
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 1.1rem;
  cursor: pointer;
}
</style>
